import { Utils } from '@genial/utils';

export const validateIsLimitTimeExceeded = (movementDate: Date, cutOffTime?: string | null) => {
  if (Utils.Date.IsToday(movementDate)) {
    if (!cutOffTime) {
      return true;
    }
    const cutOffHour = parseInt(cutOffTime.split(':')[0], 10);
    return new Date().getHours() > cutOffHour;
  }
  return false;
};
